<template>
    <section class="status">
        <div class="panel">
            <div class="panel-heading">
                <h2>My Status</h2>
            </div>
            <div v-if="loading" class="panel-body">
                <h2 class="text-center loading">Loading Data</h2>
            </div>
            <div v-else class="panel-body">
                <form>
                <div v-if="allowedToChangeStatus">
                    <div class="form-group status" v-if="status">
                        <div class="status-wrapper">
                            <label>At this point in this current term, what are you planning to do?</label>
                            <div class="controls">
                                <div>
                                    <select :class="status" @mousedown="checkAvailability($event)" @change="statusChanged=true;selectedPolicy=status; newStatus.hasReadPolicy = false" v-model="status" class="form-control">
                                        <option v-for="status in statuses" :value="status.value">{{status.label}}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="warning">
                            <p>Confirming your Status is important and must be completed before the deadline outlined in your Journey. If you miss the deadline to confirm your status it will be assumed that you are continuing with the program and will be responsible for all financial obligations. We realize that situations change, and we strive to be flexible and support our students. However, this needs to be communicated well before our term starts. If you miss the deadlines, we cannot be more lenient as we coordinate with working professionals to instruct and mentor you.</p>
                            <p>Note, if you are not enrolled in this current term (in an active deferral) you cannot update your status and you will continue in the term you selected prior to your deferral (seeing ‘unconfirmed’ in the table for your break below is expected in this case). There are changes happening with the structure and format of the online program, and it’s important that you connect with our Admissions team so they can work with you on building a plan to successfully complete your education.</p>
                        </div>
                        <div v-show="statusChanged===true">
                            <div v-if="status==='deferring' || status === 'retaking'">
                                <label v-if="status==='deferring'">When are you hoping to continue on?</label>
                                <label v-if="status==='retaking'">When do you plan to retake this term?</label>
                                <select class="form-control" v-model="newStatus.intake">
                                    <option v-for="(intake,$index) in intakes" v-if="(status==='deferring' && $index > 1) || (status==='retaking')" :value="intake.date">{{intake.label}}</option>
                                </select>
                            </div>


                            <div v-if="status==='dropping'">
                                <label>When do you plan to drop out?</label>
                                <select class="form-control" v-model="newStatus.intake">
                                    <option v-for="intake in intakes" :value="intake.date">{{intake.label}}</option>
                                </select>
                            </div>
                            <div v-if="status && status!=='continuing'">
                                <label>Reason</label>
                                <textarea class="form-control" v-model="newStatus.reason"></textarea>
                                <div class="documents">
                                    <label>Supporting Documents</label>
                                    <label class="documents"> Upload
                                        <input type="file" ref="documents" multiple>
                                    </label>
                                </div>
                            </div>
                        </div>

                        <div class="policy" v-if="selectedPolicy && selectedPolicy !== 'unconfirmed' && selectedPolicy !== 'continuing'">
                            <div v-html="policies[selectedPolicy]"></div>
                            <div v-if="selectedPolicy === 'dropping'">
                                <label><input type="checkbox" v-model="newStatus.agreedToRefundPolicy">I understand there are additional steps for a refund and that refunds are calculated based on when accounting receives the request with my banking information.<br><br>This must be checked to continue.<br><br></label>
                            </div>
                            <label><input type="checkbox" v-model="newStatus.hasReadPolicy">I have read and agree to the above policy.</label>
                        </div>


                        <button @click.prevent="updateStatus()" v-show="statusChanged===true || status === 'continuing'" class="btn btn-xs btn-success">Update Status</button>
                    </div>
                    <div v-if="pastStatuses">
                        <table class="table table-striped table-bordered past-statuses">
                            <thead>
                                <tr>
                                    <td>Date Submitted</td>
                                    <td>Status</td>
                                    <td>Reason</td>
                                    <td>Term</td>
                                    <td>Links</td>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="status in pastStatuses">
                                    <td><span v-html="$options.filters.journeyDate(status.createdAt)"></span></td>
                                    <td>{{status.status | capitalize}}</td>
                                    <td>{{status.reason}}</td>
                                    <td><span v-if="status.intake">{{status.intake | intakeDate}}</span></td>
                                    <td>
                                        <a href="#" v-for="(link, $index) in status.documents" @click.prevent="downloadDocument(link)">Link {{$index + 1}}</a>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                </div>
                                        
                    <div class="form-group">        
                        <div v-if="enrollmentLetters && enrollmentLetters.length">
                            <div v-for="letter in enrollmentLetters">
                                <a href="#" @click.prevent="downloadLetter(letter.url)">Enrollment Letter<span v-if="letter.programId"> - {{getProgramName(letter.programId)}}</span></a>                                
                            </div>
                        </div>

                        <div v-else>
                            <div v-if="extraEnrollmentLetters && extraEnrollmentLetters > 0">
                                <a class="enrollment-letter" v-for="n in extraEnrollmentLetters + 1" href="#" @click.prevent="downloadEnrollmentLetter(n)">Enrollment Letter #{{n}}</a>
                            </div>
                            <a v-else href="#" @click.prevent="downloadEnrollmentLetter()">Enrollment Letter</a>
                        </div>

                        <div v-for="document in documents">
                            <a href="#" @click.prevent="downloadSlip(document)">{{document.type}}</a>
                        </div>
                    </div>
                    <div class="form-group" v-for="(project, $index) in projects">
                        <div class="diploma-links" v-if="project.passed === true && (localStorage.roles.includes('Student') && localStorage.transitioned != 'true')">
                            <a :href="'https://ttto-graduation-certificates.s3.us-west-2.amazonaws.com/Think_Tank_Graduation_Certificate_'+localStorage.account_id+'.pdf'" _target="blank">
                                Digital Diploma (dark)
                            </a>
                            <a :href="'https://ttto-graduation-certificates.s3.us-west-2.amazonaws.com/Think_Tank_Graduation_Certificate_'+localStorage.account_id+'_print.pdf'" _target="blank">
                                Digital Diploma (light)
                            </a>
                            <p>If you would like a hard copy mailed to you, please email <a href="mailto:online@tttc.ca">online@tttc.ca</a> with your current address<br>*Mailing a hard copy may require processing fees</p>
                        </div>
                    </div>
                   
                    <div class="form-group">
                        <label>Your Picks</label>
                        <div class="indent" v-if="this.path != '9200'"><span class="bold">Pick Your Path:</span> <span v-if="pathName">{{pathName}}</span></div>
                        <div class="indent"><span class="bold">Pick Your Mentor: </span> <span v-if="mentorName">{{mentorName}}</span> </div>
                    </div>
                    <div class="form-group" v-if="metrics">
                        <label>Your Marks</label>
                        <div class="text-right download-transcript"><span @click.prevent="getTranscript">Download Transcript</span></div>
                        <div class="metrics-container">
                            
                            <div v-for="metric in metrics" v-if="metric.term.type !== 'mentorship'" class="term-metrics">
                                <div @click="toggleTerm(metric.term.id)" class="term-header">
                                    <i v-if="selectedTerms.includes(metric.term.id)" class="fa fa-caret-down"></i>
                                    <i v-else class="fa fa-caret-right"></i>
                                    {{metric.term.name}}
                                    <span class="total-mark" v-if="new Date(metric.term.endDate) < new Date()">
                                        {{metric.totalMark}}%&nbsp;&nbsp;{{letterGrade(metric.totalMark)}}
                                    </span>
                                </div>
                                <div v-show="selectedTerms.includes(metric.term.id)" class="metrics">
                                    <div>
                                        <span class="bold" v-if="usesNewMarkingSystem(metric)">10% Live Session Attendance</span>
                                        <span class="bold" v-else>25% Metrics</span>

                                        <div v-if="!usesNewMarkingSystem(metric)" class="indent clearfix">10% Video Progress: <span class="mark">{{metric.video.mark}}% {{metric.video.progress}} / {{metric.video.totalDuration}}</span></div>
                                        <div v-if="!usesNewMarkingSystem(metric)" class="indent clearfix">5% Forum / Chat: <span class="mark">{{metric.interactions.mark}}%</span></div>
                                        <div class="indent clearfix">Attendance: <span class="mark">{{metric.meetings.attended}} / {{metric.meetings.total}}</span></div>
                                    </div>
                                    <div class="clearfix">
                                        <span @click="toggleAssignments(metric.term.id)">

                                            <span class="bold" v-if="usesNewMarkingSystem(metric)">40% Assignments:</span>
                                            <span class="bold" v-else>25% Assignments:</span>
                                            <i v-if="selectedAssignments.includes(metric.term.id)" class="fa fa-caret-down"></i>
                                            <i v-else class="fa fa-caret-right"></i>
                                        </span>
                                        <span class="mark">{{metric.assignments.mark}}%</span>
                                        <div class="submissions" v-show="selectedAssignments.includes(metric.term.id)">
                                            <div v-for="assignment in metric.assignments.assignments">
                                                ID: {{assignment.id}}
                                                Week {{assignment.week}}:
                                                <span v-if="assignment.instance['associated.name']">{{assignment.instance['associated.name']}}</span>
                                                &ndash; {{assignment.name}}
                                                <!-- <pre>{{assignment.submission}}</pre> -->
                                                <span class="mark" v-if="assignment.submission">                                                    
                                                    <span v-if="assignment.submission.grade == null">Ungraded</span>
                                                    <span v-else>{{assignment.submission.grade}}</span>
                                                    <span v-if="assignment.submission.grade != null">%</span>
                                                </span>
                                                <span v-else class="mark">Incomplete</span>
                                                <span class="mark" v-else="Not Submitted"></span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="clearfix">
                                        <span class="bold">50% Final Project:</span> 
                                        <span v-if="metric.finalProject && new Date(metric.term.endDate) < new Date()" class="mark">
                                            <span v-if="metric.finalProject.submission && isNaN(metric.finalProject.mark)">Ungraded</span>
                                            <span v-if="!metric.finalProject.submission">Incomplete</span>
                                            <span v-if="metric.finalProject.submission && metric.finalProject.mark">
                                                {{metric.finalProject.mark}}%
                                            </span>
                                        </span>
                                    </div>
                                        
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>

        <div @click="showOverlay=false" class="overlay" v-if="showOverlay">
            <div class="not-allowed">
                <span class="close">&times;</span>
                <div class="text" @click.stop>
                    The ability to change your status is currently closed, please check your 
                    <router-link to="/journey">Journey</router-link> for when it will open.<br><br>
                    If you need to make any changes outside our status window, please create 
                    a <router-link to="/help">Financial Ticket</router-link> and outline your situation.                    
                </div>
            </div>
        </div>

        <div @click="showStatusChangePopup = false" class="overlay" v-if="showStatusChangePopup">
            <div class="not-allowed">
                <span class="close">&times;</span>
                <div class="text" @click.stop>
                    <p>Thank you for updating your status. The next step in your process will be to have a meeting with John Robertson, Head of Admissions, who will guide you through the next steps of the process.</p>
                    <p>He will be reaching out to you in the next 48 hours to set a meeting time. If you'd like to reach out to him directly, his email is <a href="mailto:john@tttc.ca">john@tttc.ca</a>.</p>
                </div>
            </div>


        </div>

    </section>
</template>
<script>
import paths from '../services/paths';
import mentors from '../services/mentors';
import users from '../services/users';
import aws from '../services/aws';
import courses from '../services/courses';
import finalProjects from '../services/final-projects';


import axios from 'axios';
import moment from 'moment';
import toastr from 'toastr';

export default {
    props:['userId','currentTerm'],
    data() {
        return {                        
            projects: null,
            programs: [],
            showOverlay: false,
            loading: false,
            path: null,
            pathName: null,
            focus: null,
            focusName: null,
            metrics: null,
            documents: [],
            enrollmentLetters: [],
            extraEnrollmentLetters:0,
            selectedTerms: [],
            selectedAssignments: [],
            newStatus: { hasReadPolicy:false, status: null, reason: null, intake: null, documents: null, dropping: null, softwareRequired: false },
            status: null,
            pastStatuses: null,
            statusChanged: false,
            statuses: [{ value: 'continuing', label: 'Continue On' }, { value: 'deferring', label: 'Defer Next Term' }, { value: 'dropping', label: 'Drop' }, { value: 'retaking', label: 'Retake This Term' }],
            intakes: [],
            selectedPolicy: null,
            showStatusChangePopup: false,
            policies: {
                dropping: `<p>This option can be selected at any time. However, please be aware that there are additional steps with Admissions to guide you through the process.</p><p>*Please check your email registered with Portal to complete this process.</p><p>*Refunds are calculated from the time that accounting receives the email. Refunds are issued within 30 days of receiving the request (pay runs are on the 15th and the last day of the month).</p><p><b>Refund Policy</b></p>    
                    <table class="refund-policy">
                        <tr>
                            <td colspan="1" rowspan="1">
                                <p><span class="bold">Circumstances when Refund Payable &nbsp;</span></p>
                            </td>
                            <td colspan="1" rowspan="1">
                                <p><span class="bold">Amount of Refund </span></p>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2" rowspan="1">
                                <p><span class="bold">Before program start date, </span><span>institution receives a notice of withdrawal (applies to all students)</span></p>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="1" rowspan="1">
                                <ul>
                                    <li><span>No later than seven days after student signed the enrolment contract, and </span></li>
                                    <li><span>Before the program start date. &nbsp;</span></li>
                                </ul>
                                <p><span></span></p>
                                <p><span></span></p>
                            </td>
                            <td colspan="1" rowspan="1">
                                <p><span>100% tuition and all related fees, other than application fee. Related fees include: administrative fees, application fees, assessment fees, and fees charged for textbooks or other course materials.</span></p>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="1" rowspan="1">
                                <ul>
                                    <li><span>At least 30 days before the later of:</span></li>
                                </ul>
                                <ul class="second-level">
                                    <li><span>The program start date in the most recent Letter of Acceptance (international students)</span></li>
                                    <li><span>The program start date in the enrolment contract.</span></li>
                                </ul>
                            </td>
                            <td colspan="1" rowspan="1">
                                <p><span>Institution may retain up to 10% of tuition, to a maximum of $1,000.</span></p>
                                <p><span></span></p>
                                <p><span>Institution must refund fees paid for course materials if not provided to the student.</span></p>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="1" rowspan="1">
                                <ul>
                                    <li><span>More than seven days after the student and institution signed the enrolment contract, and </span></li>
                                    <li><span>Less than 30 days before the later of:</span></li>
                                </ul>
                                <ul class="second-level">
                                    <li><span>The program start date in the most recent Letter of Acceptance (international students)</span></li>
                                    <li><span>The program start date in the enrolment contract.</span></li>
                                </ul>
                            </td>
                            <td colspan="1" rowspan="1">
                                <p><span>Institution may retain up to 20% of tuition, to a maximum of $1,300.</span></p>
                                <p><span></span></p>
                                <p><span>Institution must refund fees paid for course materials if not provided to the student.</span></p>
                                <p><span></span></p>
                                <p><span></span></p>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2" rowspan="1">
                                <p><span>After the program start date, student withdraws or is dismissed (applies to students enrolled in a program delivered solely by distance education): </span></p>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="1" rowspan="1">
                                <ul>
                                    <li><span>Student completed up to 30% of the program.</span></li>
                                </ul>
                                <p><span></span></p>
                                <p><span></span></p>
                            </td>
                            <td colspan="1" rowspan="1">
                                <p><span>Institution may retain up to 30% of the tuition</span></p>
                                <p><span>&nbsp;</span></p>
                                <p><span>Institution must refund fees paid for course materials if not provided to the student.</span></p>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="1" rowspan="1">
                                <ul>
                                    <li><span>Student completed more than 30% but less than 50% of the program (based on evaluation provided to student). </span></li>
                                </ul>
                            </td>
                            <td colspan="1" rowspan="1">
                                <p><span>Institution may retain up to 50% of the tuition.</span></p>
                                <p><span></span></p>
                                <p><span>Institution must refund fees paid for course materials if not provided to the student.</span></p>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="1" rowspan="1">
                                <ul>
                                    <li><span>Student completed more than 50% of the program (based on evaluation provided to student).</span></li>
                                </ul>
                            </td>
                            <td colspan="1" rowspan="1">
                                <p><span>Institution may retain up to 100% of the tuition.</span></p>
                                <p><span></span></p>
                                <p><span>Institution must refund fees paid for course materials if not provided to the student.</span></p>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2" rowspan="1">
                                <p><span>Student enrolled in a program without having met the admission requirements for the program </span></p>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="1" rowspan="1">
                                <ul>
                                    <li><span>If the student did not misrepresent the student&rsquo;s knowledge or skills when applying for admission and the registrar orders the institution to refund tuition and fees.</span></li>
                                </ul>
                            </td>
                            <td colspan="1" rowspan="1">
                                <p><span>100% tuition and all related fees, including application fees</span></p>
                            </td>
                        </tr>
                    </table>
                    <p>Institution must pay the tuition or fee refund <b>within 30 days</b> after receiving notice of withdrawal or refusal of study permit; providing a notice of dismissal, or the date on which the first 30% of the hours of instruction are provided (no-show).</p>`,
                retaking: '<p>One of two conditions of a retake:</p><p>-You have completed the term but feel as though you have not absorbed the knowledge required to move on or have not accomplished a passing grade</p><p>-You have been unable to continue your studies during the term but have missed the drop date for refunds</p><p>*Please note, if you choose to "retake" the term before the drop date deadline and want a refund it is not considered a retake and is actually a drop. Please select the drop option if this is the case and follow the steps outlined there. If you wish to take the term after dropping, you will have to pay full price again for the term.</p><p>Retaking the term is not free of charge but we offer a reduced tuition rate for a retake term. Please email <a href="mailto:accounting@tttc.ca">accounting@tttc.ca</a> if you discover any invoicing anomalies or have payment questions. Please also ensure you start a ticket if any software that may not have been licensed to you is expiring as changes in your term can affect software licensing.</p>',
                deferring: '<p>A deferral is essentially a gap in your studies. These are on a per term basis meaning that you can only choose to take terms off and not a specific date range. You must let Think Tank know of a deferral a minimum of 6 weeks BEFORE the term you wish to defer starts.<br><br>*You cannot defer in the middle of a term and pick up where you left off next term.<br><br>*Software is not provided during your deferral time unless you request it at an additional expense. Please check your Journey for when this will occur.</p>',
            },

        }
    },
    components: {

    },
    async mounted() {
        this.getMentor();
        await this.getUser();
        this.getPathsAndFocuses();
        this.setIntakes();
        this.getDocuments();
        this.getPrograms();
        if (localStorage.roles.includes('Student'))
            this.getProjects();
    },
    methods: {
        getPrograms() {
            courses.getPrograms().then((response)=>{
                this.programs = response.data.programs;
            });
        },
        getProgramName(id) {
            const program = this.programs.find(p => p.id === id);
            if (program) {
                return program.name;
            }
        },
        downloadSlip(doc) {            
            users.getDocument(doc);
        },
        getDocuments() {
            users.getDocuments().then((response) => {
                this.documents = response.data;
            });
        },
        getKey(num, useLegalName) {
            let name;
            if (useLegalName) {
                name = localStorage.legal_name;
            } else {
                name = localStorage.user_name;
            }

            let key = name + '_Think_Tank_Online_Enrollment_Letter_'+localStorage.account_id;
            
            if (num && num > 1) {
                key += '_'+ parseInt(num);
            }
            key += '.pdf';

            key = key.replace(/ /g, '_');

            return key;
        },
        async downloadLetter(url) {
            const key = url.split('/').pop();
            const letter = await aws.getPresignedUrl(this, 'tto-welcome-letters',key,'getObject');
            window.open(letter.data,'_blank');
            return;
        },
        async downloadEnrollmentLetter(num) {
            let key = this.getKey(num, false);
            let url = await aws.getPresignedUrl(this, 'tto-welcome-letters',key,'headObject');

            try {
                await axios.get(url.data);
                url = await aws.getPresignedUrl(this, 'tto-welcome-letters',key,'getObject');
            } catch(e) {
                key = this.getKey(num, true);
                url = await aws.getPresignedUrl(this, 'tto-welcome-letters',key,'getObject');
            }                       
            
            window.open(url.data,'_blank')
        },
        checkAvailability(e) {
            if (!this.allowed) {
                e.preventDefault();
                this.showOverlay = true;
            }
        },
        usesNewMarkingSystem(mark) {
            return !mark.video;
        },
        letterGrade(mark) {
            if (mark >= 97) return 'A+';
            if (mark >= 93) return 'A';
            if (mark >= 90) return 'A-';
            if (mark >= 87) return 'B+';
            if (mark >= 83) return 'B';
            if (mark >= 80) return 'B-';
            if (mark >= 77) return 'C+';
            if (mark >= 73) return 'C';
            if (mark >= 70) return 'C-';
            if (mark >= 67) return 'D+';
            if (mark >= 63) return 'D';
            if (mark >= 60) return 'D-';
            if (mark < 60) return 'F';
            return 'Incomplete';

        },
        getTranscript() {
            var self = this;
            this.$store.dispatch('toggle', { type: 'loading', boolean: true });
            let userId = localStorage.user_id;

            if (localStorage.roles.includes('OnlineDirector')) {
                userId = parseInt(this.userId);
            }
            users.getTranscript(this, userId).then((response) => {
                this.$store.dispatch('toggle', { type: 'loading', boolean: false });
            });
        },
        downloadDocument(url) {
            let filename = url.replace('https://s3-us-west-2.amazonaws.com/ttto-supporting-documents/', '').replace(/\+/g, ' ');
            aws.getPresignedUrl(this, 'ttto-supporting-documents', filename, 'getObject').then(function(presignedUrl) {
                window.open(presignedUrl.data);
            });

        },
        updateStatus() {
            if (!this.allowed) {
                this.showOverlay = true;
                return false;
            }
            if (this.status !== 'continuing' && (!this.newStatus.reason)) {
                toastr.error('Please provide a reason');
                return false;
            }

            if (this.status === 'deferring' && (!this.newStatus.intake)) {
                toastr.error('Please provide a deferral date');
                return false;
            }

            if (this.status !== 'continuing' && this.newStatus.hasReadPolicy !== true) {
                toastr.error('Please read the policies for this status');
                return false;
            }

            if (this.status === 'dropping' && this.newStatus.agreedToRefundPolicy !== true) {
                toastr.error('Please agree to the refund policy');
                return false;
            }

            if (this.status !== 'continuing') {
                this.showStatusChangePopup = true;
            }

            let status = this.newStatus;
            status.status = this.status; 

            if (!status.documents) status.documents = [];
            let files = [];

            if (this.$refs.documents) files = Array.from(this.$refs.documents.files);

            let promises = [];

            let userId;
            if (this.userId) { userId = this.userId; } else { userId = localStorage.user_id; }


            files.forEach(function(file) {

                let filename = file.name;
                filename = filename.replace(/^\w+$/g, '');

                let promise = new Promise(function(resolve, reject) {
                    aws.signature(file, userId + '/' + filename, 'ttto-supporting-documents').then(function(signature) {
                        aws.upload(file, userId + '/' + filename, signature, 'ttto-supporting-documents').then(function(response) {
                            status.documents.push(response.url);
                            resolve();
                        });
                    });
                });
                promises.push(promise);
            });

            Promise.all(promises).then(() => {
                const data = {
                    status: status
                }
                users.updateStatus(this, data, this.userId).then((response) => {
                    response.data.success === true ? toastr.success('Status updated') : toastr.error(response.data.message);
                    if (response.data.success === true) {
                        this.statusChanged = false;
                        this.newStatus = { hasReadPolicy:false, status: null, reason: null, intake: null, documents: null };
                        this.getUser();
                        

                    }
                })
            });

        },
        setIntakes() {
            let intakes = [];
            let cutoff;

            if (this.currentTerm) {
                cutoff = this.currentTerm.startDate;
            } else {
                cutoff = this.$store.getters.currentTerm.startDate
            }

            cutoff = moment(cutoff).subtract(1,'week').toDate();

            const currentMonth = cutoff.getMonth();
            const currentYear = cutoff.getFullYear();
            for (let i = 0; i < 4; i++) {
                intakes.push({ date: currentYear + i + '-02-01', label: 'February ' + (currentYear + i) });
                intakes.push({ date: currentYear + i + '-06-01', label: 'June ' + (currentYear + i) });
                intakes.push({ date: currentYear + i + '-10-01', label: 'October ' + (currentYear + i) });
            }
            intakes = intakes.filter(function(i) { return moment(i.date).toDate() > cutoff });
            this.intakes = intakes;
        },
        getUser() {
            return users.getMe(this, this.userId).then((response) => {
                const student = response.data.person;
                this.extraEnrollmentLetters = student.upsells;
                if (student.letters) {
                    this.enrollmentLetters = student.letters.filter(l => l.type === 'enrollment_letter');
                }                

                this.path = student.path;
                this.focus = student.focus;

                if (student.student_statuses.length === 0) { // this is a demo user that was not set up right
                    student.student_statuses = [{status: 'unknown'}]
                }

                this.status = student.student_statuses[0].status;                
                this.pastStatuses = student.student_statuses;

                if (student.marks && student.marks.length > 0) {
                    this.metrics = student.marks
                        .sort((a, b) => { return new Date(a.marks.term.startDate) - new Date(b.marks.term.startDate) })
                        .map((m) => {
                            if (m.mark_overrides && m.mark_overrides.length > 0) {
                                let overrides = m.mark_overrides.sort((a, b) => { return new Date(b.createdAt) - new Date(a.createdAt) });
                                m.marks = overrides[0].marks;
                                m.overridden = true;
                            }
                            return m.marks;
                        });
                }
                return true;
            });
        },
        toggleTerm(id) {
            let index = this.selectedTerms.indexOf(id);
            index > -1 ? this.selectedTerms.splice(index, 1) : this.selectedTerms.push(id);
        },
        toggleAssignments(id) {
            let index = this.selectedAssignments.indexOf(id);
            index > -1 ? this.selectedAssignments.splice(index, 1) : this.selectedAssignments.push(id);
        },
        
        getPathsAndFocuses() {

            paths.getPaths(true).then((allPaths) => {
                allPaths.forEach((path) => {
                    if (this.path && this.path == path.id) {
                        this.pathName = path.name;
                    }
                    if (this.focus && this.focus == path.id) {
                        this.focusName = path.name;
                    }
                })
            });
        },

        async getMentor() {
            let requests = await mentors.getRequests(this.userId);
            let finalized = requests.data.requests.find((r) => {

                return r.approvedByMentor && r.approvedByStudent && r.studentId == parseInt(localStorage.user_id);
            });
            console.log(requests.data)

            if (finalized && finalized.mentor) {
                this.mentorName = finalized.mentor.firstName + ' ' + finalized.mentor.lastName;
            }
        },       
        getProjects() {
            var self = this;
            return finalProjects.get().then(function(response) {
                // console.log(response.data)
                self.projects = response.data.projects.sort(function(a,b) { return new Date(a.createdAt) - new Date(b.createdAt)});
                self.latestSubmission = self.projects[self.projects.length - 1];
                self.$forceUpdate();
                return true;
            })
        },

    },
    computed: {
        allowedToChangeStatus() {
            return false;
        },
        allowed() {
            if (this.$store.getters.settings) {
                const setting = this.$store.getters.settings.find((s)=> { return s.name === 'statusChangesAllowed'});
                return setting.value;
            }
            return false;
        },
    }
}

</script>
<style lang="scss">
    .diploma-links {
        a {
            margin-right:1rem;
        }
    }
    .policy ul {
      list-style: disc!important;
      padding-left:4rem;
    }

    table.refund-policy {
        margin-bottom:2rem;
        .bold {
            font-weight:700;
        }
        td {
            border:1px solid #ccc;
            padding:18px 12px;
            vertical-align:top;
        }
        ul {
            padding-left:2rem;
        }
        .second-level {
            padding-left:4rem;
            li {
                list-style-type:circle;
            }
        }
    }

</style>
<style lang="scss" scoped>

.warning {
    padding:1.4rem 0;
}
.overlay {
    background:rgba(0,0,0,.6);
    z-index:999999999;
    display:flex;
    align-items:center;
    justify-content:center;
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
}

.not-allowed {
    background: #222222;
    border: 1px solid #b0b0b0;
    color: #b0b0b0;
    font-size:14px;
    position: relative;
    width: 400px;
    padding:1rem;
    padding-right:6rem;
    .close {
        position: absolute;
        top:-2px;
        right:1px;
        font-weight:400;
        cursor:pointer;
    }
}

.policy {
    margin:1rem 0;

    label {

        input {
            cursor:pointer;
            margin-right:.5rem;
        }
    }
}


label {
    font-size: 1.25em;
}

.bold {
    font-weight: 700;
}

.download-transcript {
    margin-bottom: .5rem;

    span {
        color: #3cf;
        cursor: pointer;
    }
}

table.past-statuses {

    a {
        display: block;
        white-space: nowrap;
    }
}

@keyframes pulse {
    from {
        transform: scale3d(1, 1, 1);
    }

    50% {
        transform: scale3d(1.05, 1.05, 1.05);
    }

    to {
        transform: scale3d(1, 1, 1);
    }
}

.loading {
    animation-duration: 2s;
    animation-fill-mode: both;
    animation-iteration-count: infinite;
    animation-name: pulse;
    margin: 10rem 0;
}

.highlight {
    font-weight: 400;
    color: #3cf;
}

.indent {
    padding-left: 3rem;

    &.payments {
        margin-left: -1rem;
    }
}

.mark {
    background: initial;
    float: right;
    display: block;
}

form {
    padding: 2rem;
}

div.documents {
    margin-top: 2rem;
}

label.documents {
    border: 1px solid #b0b0b0;
    padding: .5rem 1rem;

    input {
        display: none;
    }
}

textarea.form-control {
    border: 1px solid #b0b0b0 !important;
    height: 10rem;
}

.metrics-container {

    //        border:1px solid #b0b0b0;
    .term-metrics:last-child .term-header {
        border-bottom: 1px solid #b0b0b0;
    }

    i {
        cursor: pointer;
    }
}

.term-metrics {
    .term-header {
        border: 1px solid #b0b0b0;
        padding: 1rem;
        border-bottom: none;
        cursor: pointer;
        font-size: 1.2em;
        font-weight: bold;

        .total-mark {
            float: right;
        }
    }

    .metrics {
        padding: 1rem;
        border: 1px solid #b0b0b0;
    }

    .submissions {
        border: 1px solid #b0b0b0;
        padding: 1rem;
        margin: 1rem -1rem;

        &>div {
            border-bottom: 1px solid #b0b0b0;
            padding: .5rem 0;
        }

        &>div:last-child {
            border-bottom: none;
        }
    }
}

.payments {
    display: flex;

    span {
        width: 50px;
        padding: 1rem;
    }
}

.status-wrapper {
    display: flex;

    label {
        padding-top: 1rem;
    }

    select {
        margin-left: 1rem;
        padding: .5rem 1rem;
        height: auto;
        margin-top: .5rem;
    }
}

.status {
    .controls {
        display: flex;
        margin-bottom: 1rem;

        .continuing {
            background: #9ed4b5 !important;
            color: #1a1a1a;
        }

        .deferring {
            background: #ff9e4a !important;
            color: #1a1a1a;
        }

        .dropping {
            background: #ffffff !important;
            color: #1a1a1a;
        }

        .retaking {
            background: #add0f5 !important;
            color: #1a1a1a;
        }
    }

    button {
        padding: .5rem;
        margin-top: 1rem;
    }
}
a.enrollment-letter {
    display:block;
    margin-bottom:.5rem;
}

</style>



// WEBPACK FOOTER //
// Status.vue?06645423